<template>
    <div>
        <div class="center">
            <h2 class="not__title">404</h2>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>